import { Link } from "react-router-dom";
import Monogram from "./Monogram";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="font-body mt-24 border-t border-[color:var(--rc-divider)] bg-[color:var(--rc-bg)]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-wrap justify-between items-start gap-10">
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-2.5 mb-3" style={{ color: "var(--rc-text)" }}>
              <Monogram size={32} />
              <span className="font-display text-lg font-semibold tracking-tight" style={{ letterSpacing: "-0.015em" }}>
                Rebel<span className="text-[#2d7cf6]">&amp;Co</span>
              </span>
            </Link>
            <p data-testid="footer-tagline" className="text-sm text-[color:var(--rc-text-muted)] leading-relaxed">
              Gay sexual wellness for rebels who love their bodies.
            </p>
          </div>

          <div className="flex gap-10 sm:gap-16 flex-wrap">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)] mb-3">Explore</h4>
              {[["/experiences", "Experiences"], ["/cities", "Cities"], ["/about", "About"], ["/rebel-notes", "Rebel Notes"]].map(([to, label]) => (
                <Link key={to} to={to} className="block text-sm text-[color:var(--rc-text-dim)] hover:text-[color:var(--rc-text)] transition-colors py-1" style={{ minHeight: 32 }}>{label}</Link>
              ))}
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)] mb-3">Account</h4>
              {[["/login", "Client login"], ["/signup", "Create account"], ["/contact", "Contact"], ["/privacy", "Privacy"]].map(([to, label]) => (
                <Link key={to} to={to} className="block text-sm text-[color:var(--rc-text-dim)] hover:text-[color:var(--rc-text)] transition-colors py-1" style={{ minHeight: 32 }}>{label}</Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[color:var(--rc-divider)] flex flex-wrap justify-between items-center gap-3">
          <p className="text-xs text-[color:var(--rc-text-dim)]">© 2026 Rebel&amp;Co · 21+ only · Private by design</p>
          <p className="text-xs text-[color:var(--rc-text-dim)]">What you explore is yours.</p>
        </div>
      </div>
    </footer>
  );
}
